import _ from 'lodash'
import axios from 'axios'
import { apiURL } from '@/config'
import router from '@/router'
import { parseSavoyNetFromApi } from '@/utils/savoynet'

function normalizeImovelSavoyNet (imovel) {
  if (!imovel || typeof imovel !== 'object') {
    return imovel
  }

  return Object.assign({}, imovel, {
    savoynet: parseSavoyNetFromApi(imovel.savoynet)
  })
}

const imoveis = {
  namespaced: true,
  state: {
    lista: {
      data: [],
      paginacao: {}
    },
    listaFiltros: {
      proprietario: [],
      tipo: [],
      uf: [],
      loteamento: []
    },
    listaDownload: [],
    filtros: {},
    proprietarios: [],
    detalhes: {}
  },
  mutations: {
    INSERT_LISTA (state, payload) {
      const normalizedPayload = _.map(payload, normalizeImovelSavoyNet)
      state.lista.data = _.uniqBy(_.union(state.lista.data, normalizedPayload), 'id')
    },
    SET_LISTA_PAGINACAO (state, payload) {
      state.lista.paginacao = payload
    },
    SET_LISTA_DOWNLOAD (state, payload) {
      state.listaDownload = _.map(payload, normalizeImovelSavoyNet)
    },
    SET_DETALHES (state, payload) {
      state.detalhes = normalizeImovelSavoyNet(payload)
    },
    SET_PROPRIETARIOS (state, payload) {
      state.proprietarios = payload
    },
    SET_LISTA_FILTROS (state, payload) {
      Object.keys(state.listaFiltros).forEach((key) => {
        state.listaFiltros[key] = payload[key]
      })
    },
    SET_FILTROS (state, payload) {
      state.filtros = payload
    },
    CLEAR_FILTROS () {},
    CLEAR_LISTA (state) {
      state.lista.data.length = 0
      state.lista.paginacao = {}
    },
    CLEAR_DETALHES (state) {
      state.detalhes = {}
    },
    INSERT_OBSERVACAO (state, payload) {
      state.detalhes.observacoes.data.unshift(payload)
    },
    UPDATE_OBSERVACAO (state, payload) {
      _.find(state.detalhes.observacoes.data, payload.item).conteudo = payload.conteudo
    },
    DELETE_OBSERVACAO (state, payload) {
      state.detalhes.observacoes.data.splice(state.detalhes.observacoes.data.indexOf(payload), 1)
    },
    INSERT_ANEXO (state, payload) {
      state.detalhes.anexos.data.unshift(payload)
    },
    UPDATE_ANEXO (state, payload) {
      _.find(state.detalhes.anexos.data, payload.item).legenda = payload.legenda
    },
    DELETE_ANEXO (state, payload) {
      state.detalhes.anexos.data.splice(state.detalhes.anexos.data.indexOf(payload), 1)
    },
    INSERT_FOTO (state, payload) {
      state.detalhes.fotos.data.unshift(payload)
    },
    UPDATE_FOTO (state, payload) {
      _.find(state.detalhes.fotos.data, payload.item).legenda = payload.legenda
    },
    DELETE_FOTO (state, payload) {
      state.detalhes.fotos.data.splice(state.detalhes.fotos.data.indexOf(payload), 1)
    },
    DELETE_TAREFA (state, payload) {
      state.detalhes.tarefas.data.splice(state.detalhes.tarefas.data.indexOf(payload), 1)
    },
    REALIZAR_TAREFA (state, payload) {
      const tarefa = _.find(state.detalhes.tarefas.data, { id: payload.id })
      if (!tarefa) {
        return
      }
      tarefa.realizada = true
    },
    INSERT_TAXA (state, payload) {
      state.detalhes.taxas.data.unshift(payload)
    },
    UPDATE_TAXA (state, payload) {
      const taxa = _.find(state.detalhes.taxas.data, payload.item)
      taxa.numero = payload.data.numero
      taxa.situacao = payload.data.situacao
      taxa.ajuizado_cliente = payload.data.ajuizado_cliente
      taxa.ajuizado_processo = payload.data.ajuizado_processo
    },
    DELETE_TAXA (state, payload) {
      state.detalhes.taxas.data.splice(state.detalhes.taxas.data.indexOf(payload), 1)
    }
  },
  actions: {
    loadLista ({ commit, dispatch }, payload) {
      if (payload.loading !== false) {
        dispatch('utils/showLoading', { transparent: true }, { root: true })
      }
      axios.get(`${apiURL}/imoveis`, { params: payload }).then((response) => {
        commit('INSERT_LISTA', response.data.data)
        commit('SET_LISTA_PAGINACAO', response.data.meta.pagination)
        dispatch('utils/hideLoading', {}, { root: true })
      }, () => {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        router.push('/')
      })
    },
    loadListaFiltros ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', { transparent: true }, { root: true })
      axios.get(`${apiURL}/filtros`, { params: payload }).then((response) => {
        commit('SET_LISTA_FILTROS', response.data)
        dispatch('utils/hideLoading', {}, { root: true })
      }, () => {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        router.push('/')
      })
    },
    setFiltros ({ commit }, payload) {
      commit('SET_FILTROS', payload)
    },
    clearFiltros ({ commit }) {
      commit('CLEAR_FILTROS')
    },
    loadListaDownload ({ commit, dispatch }, payload) {
      payload.download = true
      return new Promise((resolve, reject) => {
        axios.get(`${apiURL}/imoveis`, { params: payload }).then((response) => {
          commit('SET_LISTA_DOWNLOAD', response.data.data)
          resolve()
        }, () => {
          dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.',
            persistent: true
          }, { root: true })
          reject()
          router.push('/')
        })
      })
    },
    loadListaSelect ({ dispatch }, payload = {}) {
      const baseParams = Object.assign({}, payload, {
        fields: 'id,apelido',
        download: true
      })

      const mapItems = (response) => {
        return _.map(response.data.data || [], (item) => ({
          id: item.id,
          apelido: item.apelido || `Imóvel #${item.id}`
        }))
      }

      const loadPage = (page) => {
        return axios.get(`${apiURL}/imoveis`, {
          params: Object.assign({}, baseParams, { page })
        })
      }

      const appendUniqueItems = (allItems, newItems) => {
        const existingIds = new Set(allItems.map(item => String(item.id)))
        let added = 0

        newItems.forEach((item) => {
          const id = String(item.id)
          if (existingIds.has(id)) return
          existingIds.add(id)
          allItems.push(item)
          added++
        })

        return added
      }

      const extractTotalPages = (response) => {
        const pagination = _.get(response, 'data.meta.pagination', {})
        const total = parseInt(pagination.total || _.get(response, 'data.meta.total') || 0)
        const perPage = parseInt(
          pagination.per_page ||
          pagination.page_size ||
          _.get(response, 'data.meta.per_page') ||
          _.get(response, 'data.meta.page_size') ||
          0
        )
        const calculatedTotalPages = perPage > 0 && total > 0 ? Math.ceil(total / perPage) : 0
        const totalPages = parseInt(
          pagination.total_pages ||
          pagination.last_page ||
          _.get(response, 'data.meta.total_pages') ||
          _.get(response, 'data.meta.last_page') ||
          calculatedTotalPages ||
          0
        )

        return Number.isFinite(totalPages) ? totalPages : 0
      }

      const loadRemainingPagesSequentially = ({ totalPages, allItems, page }) => {
        if (totalPages > 0 && page > totalPages) {
          return _.uniqBy(allItems, 'id')
        }

        if (page > 100) {
          return _.uniqBy(allItems, 'id')
        }

        return loadPage(page).then((response) => {
          const pageItems = mapItems(response)
          if (pageItems.length < 1) {
            return _.uniqBy(allItems, 'id')
          }

          const added = appendUniqueItems(allItems, pageItems)
          if (added < 1) {
            return allItems
          }

          return loadRemainingPagesSequentially({
            totalPages,
            allItems,
            page: page + 1
          })
        }, () => allItems)
      }

      return loadPage(1).then((response) => {
        const firstPageItems = _.uniqBy(mapItems(response), 'id')
        const totalPages = extractTotalPages(response)

        if (firstPageItems.length < 1) {
          return []
        }

        if (totalPages <= 1) {
          return loadRemainingPagesSequentially({
            totalPages: 0,
            allItems: firstPageItems.slice(),
            page: 2
          })
        }

        return loadRemainingPagesSequentially({
          totalPages,
          allItems: firstPageItems.slice(),
          page: 2
        })
      }).catch(() => {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        return Promise.reject(new Error('loadListaSelect_failed'))
      })
    },
    loadImovel ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })
      return axios.get(`${apiURL}/imoveis/${payload.id}`).then((response) => {
        commit('SET_DETALHES', response.data.data)
        dispatch('utils/hideLoading', {}, { root: true })
        return response.data.data
      }, (error) => {
        const status = error && error.response ? error.response.status : null
        const text = status === 403
          ? 'Sem permissão para acessar este imóvel.'
          : 'Servidor indisponível. Tente novamente mais tarde.'

        dispatch('utils/showSnackbar', {
          text,
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        if (status === 403) {
          router.push({ name: 'ImoveisLista' })
          return Promise.reject(error)
        }
        router.push('/')
        return Promise.reject(error)
      })
    },
    loadProprietarios ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })
      axios.get(`${apiURL}/proprietarios`).then((response) => {
        commit('SET_PROPRIETARIOS', response.data)
        dispatch('utils/hideLoading', {}, { root: true })
      }, () => {
        dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        router.push('/')
      })
    },
    clearLista ({ commit }) {
      commit('CLEAR_LISTA')
    },
    clearImovel ({ commit }) {
      commit('CLEAR_DETALHES')
    },
    insertObservacao ({ commit }, payload) {
      commit('INSERT_OBSERVACAO', payload)
    },
    updateObservacao ({ commit }, payload) {
      commit('UPDATE_OBSERVACAO', payload)
    },
    deleteObservacao ({ commit }, payload) {
      commit('DELETE_OBSERVACAO', payload)
    },
    insertAnexo ({ commit }, payload) {
      commit('INSERT_ANEXO', payload)
    },
    updateAnexo ({ commit }, payload) {
      commit('UPDATE_ANEXO', payload)
    },
    deleteAnexo ({ commit }, payload) {
      commit('DELETE_ANEXO', payload)
    },
    insertFoto ({ commit }, payload) {
      commit('INSERT_FOTO', payload)
    },
    updateFoto ({ commit }, payload) {
      commit('UPDATE_FOTO', payload)
    },
    deleteFoto ({ commit }, payload) {
      commit('DELETE_FOTO', payload)
    },
    deleteTarefa ({ commit }, payload) {
      commit('DELETE_TAREFA', payload)
    },
    realizarTarefa ({ commit }, payload) {
      commit('REALIZAR_TAREFA', payload)
    },
    insertTaxa ({ commit }, payload) {
      commit('INSERT_TAXA', payload)
    },
    updateTaxa ({ commit }, payload) {
      commit('UPDATE_TAXA', payload)
    },
    deleteTaxa ({ commit }, payload) {
      commit('DELETE_TAXA', payload)
    }
  },
  getters: {
    lista (state) {
      return state.lista.data
    },
    listaPaginacao (state) {
      return state.lista.paginacao
    },
    listaDownload (state) {
      return state.listaDownload
    },
    proprietarios (state) {
      return state.proprietarios
    },
    listaFiltros (state) {
      return state.listaFiltros
    },
    filtros (state) {
      return state.filtros
    },
    detalhes (state) {
      return state.detalhes
    },
    observacoes: (state) => (tipo) => {
      if (!_.has(state.detalhes, 'observacoes.data')) {
        return []
      }
      return _.filter(state.detalhes.observacoes.data, { tipo })
    },
    anexos: (state) => (tipo) => {
      if (!_.has(state.detalhes, 'anexos.data')) {
        return []
      }
      return _.filter(state.detalhes.anexos.data, { tipo })
    },
    fotos: (state) => (tipo) => {
      if (!_.has(state.detalhes, 'fotos.data')) {
        return []
      }
      return _.filter(state.detalhes.fotos.data, { tipo })
    },
    tarefas (state) {
      if (!_.has(state.detalhes, 'tarefas.data')) {
        return []
      }
      return state.detalhes.tarefas.data
    },
    tarefasPendentes (state) {
      if (!_.has(state.detalhes, 'tarefas.data')) {
        return []
      }
      return _.filter(state.detalhes.tarefas.data, { realizada: false })
    },
    tarefaById: (state) => (tarefaId) => {
      if (!_.has(state.detalhes, 'tarefas.data')) {
        return {}
      }
      return _.head(_.filter(state.detalhes.tarefas.data, { id: tarefaId }))
    },
    vistoria: (state) => {
      if (!_.has(state.detalhes, 'vistoria.data')) {
        return {}
      }
      return state.detalhes.vistoria.data
    },
    taxas (state) {
      if (!_.has(state.detalhes, 'taxas.data')) {
        return []
      }
      return state.detalhes.taxas.data
    }
  }
}

export default imoveis



// WEBPACK FOOTER //
// ./src/vuex/modules/imoveis.js